import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Colors } from '../Constant/Color';
import { useSelector } from 'react-redux';
import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { paymentMethod } from '../Redux/LoginReduces';
import { Text, View } from '@react-pdf/renderer';



const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: "80vh",
  overflow: "auto",
  transform: 'translate(-50%, -50%)',
  width: { lg: "80%", md: "90%", sm: "90%", xs: "100%" },
  borderRadius: "10px",
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 2,
};




function InvoiceModal({ heading, text, headingTextStyle, textStyle, containerStyle, open, closeModal, buttonContainerStyle, buttonStyle, buttonStyle2, confirm, specialTextStyle, buttonText, specialText,selectedCustomer }) {

const [selectVersion,setSelectVersion] = React.useState("lts")
  let selectedInvoice = useSelector(
    (state) => state.loginReducer.selectedInvoice
  );
  const userData = useSelector((state) => state.loginReducer.updatedState);
  const vat = useSelector(state => state?.loginReducer?.vat)

  let [otherDetails,setOtherDetails] = React.useState({ ...selectedInvoice })

  React.useEffect(()=>{
if (selectVersion=="lts") {
   setOtherDetails({ ...selectedInvoice })
}else{
  //console.log(selectedInvoice?.history[Number(selectVersion-1)],"selectVersions")
setOtherDetails({ ...(selectedInvoice?.history[Number(selectVersion-1)]),customerDetails:selectedInvoice?.customerDetails })
}
  },[selectVersion])


const priceLevelId = otherDetails?.customerDetails?.[0]?.priceLevel?.[0]?.id ?? 0;
//console.log(priceLevelId)
otherDetails.productDetails = otherDetails?.productDetails?.map((e) => {
  return {
    ...e,
    rate:e?.discountPrice?Number(e?.discountPrice): priceLevelId == 1
      ? e.trade_price
      : priceLevelId == 2
      ? e.warehouse_price
      : priceLevelId == 4
      ? e.diamond
      : e.retail_price
  };
});
otherDetails.returnProductDetails = otherDetails?.returnProductDetails?.length!=0&&otherDetails?.returnProductDetails?.map((e) => {
  return {
    ...e,
   rate:e?.discountPrice?Number(e?.discountPrice): priceLevelId == 1
      ? e.trade_price
      : priceLevelId == 2
      ? e.warehouse_price
      : priceLevelId == 4
      ? e.diamond
      : e.retail_price
  };
});
//console.log(otherDetails)

  return (
    <div  >
      <Modal
        open={open}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={[style, { containerStyle }]}>

{(userData.role_access
              ?.find((e) => e.name === "PointOfSale")
              ?.subcategory?.find(
                (e) => e.name === "ShowEditInvoiceVersion" && e.selected
              ) || userData.role == "admin")&&(selectedInvoice?.history&&<div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
  {selectedInvoice?.history?.map((e,ind)=>(
    <div onClick={()=>setSelectVersion(ind+1)} style={{backgroundColor:selectVersion==(ind+1)?Colors.button:"#e6e6e6",padding:"2px 10px",borderRadius:10,cursor:"pointer",color:selectVersion==(ind+1)?"white":"black"}}>V{ind+1}</div>
  ))}
  <div onClick={()=>setSelectVersion("lts")} style={{backgroundColor:selectVersion=="lts"?Colors.button:"#e6e6e6",cursor:"pointer",padding:"2px 10px",borderRadius:10,color:selectVersion=="lts"?"white":"black"}}>LTS</div>
</div>)}

          <div xs={12} container  >



            {(otherDetails?.vatAmount||otherDetails?.isVatMargin) ? <Grid xs={12} sm={12} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }} >

              <Typography sx={{ fontFamily: "Poppins", fontWeight: "bold", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "left" }} >
                {vat?.nickName||vat?.companyName}
              </Typography>
              <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "left" }} >
                {vat?.companyAddress}
              </Typography>

              <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "left" }} >
                {vat?.mobileNumber}
              </Typography>

              <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "left" }} >
                {vat?.companyEmail}
              </Typography>


              {(otherDetails?.vatAmount||otherDetails?.isVatMargin) && <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "right" }} >

                Vat Number : {vat?.vatNumber}

              </Typography>}


              {(otherDetails?.vatAmount||otherDetails?.isVatMargin) && <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "right" }} >

                Company Number : {vat?.companyNumber}

              </Typography>}



            </Grid> : ""}

            <Grid xs={8} sm={6} >

              {otherDetails?.customerDetails && otherDetails.customerDetails.length > 0 && otherDetails.customerDetails[0]?.accountManager && <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "left" }} >
                {otherDetails.customerDetails[0]?.accountManager}

              </Typography>}

              {otherDetails.customerDetails && otherDetails.customerDetails?.length > 0 && otherDetails?.customerDetails[0]?.businessName && <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "left" }} >
                Business Name: {otherDetails?.customerDetails[0]?.businessName}
              </Typography>}

              {otherDetails.customerDetails && otherDetails.customerDetails?.length > 0 && otherDetails?.customerDetails[0]?.accountNo && <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "left" }} >
                Account Number: {otherDetails?.customerDetails[0]?.accountNo}
              </Typography>}

              <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "left" }} >
                {otherDetails?.extCustomer?.Name?(`Customer Name: ${otherDetails?.extCustomer?.Name}`):(`Customer Name: ${otherDetails.customerName}`)}
              </Typography>



              {otherDetails?.customerDetails && otherDetails.customerDetails.length > 0 && <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "left" }} >
                {otherDetails?.extCustomer?.address?(`Customer Address: ${otherDetails?.extCustomer?.address}`):(`Customer Address: ${otherDetails.customerDetails[0]?.address}`)}
              </Typography>}

              {
                otherDetails?.extCustomer?.phonenumber?(<Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "left" }} >
                {(`Phone Number: ${otherDetails?.extCustomer?.phonenumber}`)}
              </Typography>):<></>
              }

              {otherDetails?.customerType && <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "left" }} >
                Customer Type: {otherDetails?.customerType}
              </Typography>}


              {otherDetails?.customerDetails && otherDetails.customerDetails.length > 0 && otherDetails.customerDetails[0]?.email && <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "left" }} >
                Customer Email: {otherDetails?.customerDetails[0]?.email}
              </Typography>}
              {otherDetails?.customerDetails && otherDetails.customerDetails.length > 0 && otherDetails?.customerDetails[0]?.comment && <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "left", color: "red" }} >
                Comments: {otherDetails?.customerDetails[0]?.comment}
              </Typography>}

              {/* {otherDetails?.customerDetails && otherDetails.customerDetails.length > 0 && (otherDetails?.customerDetails[0]?.address || otherDetails?.customerDetails[0]?.deliveryAddress) && <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "left",color:"purple" }} >
                                Delivery Address: {otherDetails?.customerDetails[0]?.deliveryAddress || otherDetails?.customerDetails[0]?.address }
                            </Typography>} */}

            </Grid>


            <Grid xs={4} sm={6} >

              <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "right" }} >

                Invoice #: {otherDetails.invoiceNumber}

              </Typography>


              <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "right" }} >

                Date: {otherDetails.saleDate ? new Date(otherDetails.saleDate).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric"
                }) : otherDetails.saleReturnDate ?
                  new Date(otherDetails.saleReturnDate).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  }) : otherDetails?.exchangeDate ? new Date(otherDetails.exchangeDate).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })
                    :
                    otherDetails?.claimDate ? new Date(otherDetails.claimDate).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })
                      :
                      new Date(otherDetails?.warrantyDate).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })

                }


              </Typography>
              <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "right" }} >

                Time : {otherDetails.saleDate ? new Date(otherDetails.saleDate).toLocaleTimeString()
                  : otherDetails?.saleReturnDate ?
                    new Date(otherDetails.saleReturnDate).toLocaleTimeString()
                    : otherDetails?.exchangeDate ? new Date(otherDetails.exchangeDate).toLocaleTimeString() :
                      otherDetails?.claimDate ? new Date(otherDetails.claimDate).toLocaleTimeString()
                        :
                        new Date(otherDetails?.warrantyDate).toLocaleTimeString()


                }


              </Typography>

              {otherDetails?.newDate?<> <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "right" }} >

                Edit Date: {otherDetails?.newDate ? new Date(otherDetails?.newDate).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric"
                }) :""

                }


              </Typography>
              <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "right" }} >

                Edit Time : {otherDetails?.newDate ? new Date(otherDetails?.newDate).toLocaleTimeString()
                  : ""


                }


              </Typography></>:<></>}

              {(otherDetails.returnInvoiceRef || otherDetails?.claimInvoiceRef || otherDetails?.warrantyInvoiceRef) && <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "right" }} >

                Invoice Ref #: {Array?.isArray(otherDetails?.returnInvoiceRef) ? otherDetails?.returnInvoiceRef?.map((e) => e) : otherDetails?.returnInvoiceRef}


              </Typography>}


              {/* {otherDetails?.invoiceRefDate && <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "right" }} >

                                Invoice Ref Date: {new Date(otherDetails.invoiceRefDate).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                })}


                            </Typography>} */}
              {/* {otherDetails?.invoiceRefDate && <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "right" }} >

                                Invoice Ref Time : {new Date(otherDetails.invoiceRefDate).toLocaleTimeString()}


                            </Typography>} */}



              {otherDetails?.warrantyRefDate && <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "right" }} >

                Invoice Ref Date: {new Date(otherDetails.warrantyRefDate).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })}


              </Typography>}
              {otherDetails?.warrantyRefDate && <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "right" }} >

                Invoice Ref Time : {new Date(otherDetails.warrantyRefDate).toLocaleTimeString()}


              </Typography>}



              {(otherDetails?.paymentMethod) && <Typography sx={{ color: Array.isArray(otherDetails?.paymentMethod) && otherDetails?.paymentMethod?.some((e) => e.toLowerCase() == "credit") ? Colors.red : Colors.green, fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "right" }} >

                Payment Method : {Array.isArray(otherDetails.paymentMethod) ? otherDetails?.paymentMethod?.map((e, i) => e).join(",") : otherDetails?.paymentMethod}


              </Typography>}




              {otherDetails?.status && <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "right" }} >

                Status : {otherDetails?.status}


              </Typography>}

              {otherDetails?.reason && <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "right", color: Colors.red, fontWeight: "bold" }} >

                Reason : {otherDetails?.reason}


              </Typography>}


              {(Array.isArray(otherDetails?.paymentMethod) && otherDetails?.paymentMethod?.some((e, i) => e.toLowerCase() == "cheque") && !otherDetails.saleReturnDate) && <Box> <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "right" }} >

                Cheque No : {otherDetails?.cheque_no}


              </Typography>

                <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "right" }} >

                  Bank Name : {otherDetails?.bank_name}


                </Typography>

                <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "right" }} >

                  Cheque Date : {new Date(otherDetails?.clear_date)?.toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })}


                </Typography>

              </Box>



              }


              {Array.isArray(otherDetails?.paymentMethod) && otherDetails?.paymentMethod?.some((e, i) => e.toLowerCase() == "online") && <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "right" }} >

                Reference Id : {otherDetails?.referenceId}

              </Typography>}


              {Array.isArray(otherDetails?.paymentMethod) && otherDetails?.paymentMethod?.some((e, i) => e.toLowerCase() == "card") && <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "right" }} >

                Transaction Id : {otherDetails?.transactionId}

              </Typography>}


              {Array.isArray(otherDetails?.paymentMethod) && otherDetails?.paymentMethod?.some((e, i) => e.toLowerCase() == "credit") && <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px" }, textAlign: "right" }} >

                Credit Days : {otherDetails?.creditDays}

              </Typography>}

            </Grid>

            {/* <Grid container xs={12} sx={{ marginTop: 2 }} >
              <Grid xs={5} >

                <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", borderBottom: `1px solid ${Colors.border}`, marginBottom: 2 }} >

                  Product Name

                </Typography>

                {otherDetails.productDetails.map((e, i) => {

                  return (


                    <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "14px" }, fontWeight: "400" }} >

                      {e.product_name}

                    </Typography>

                  )

                })}

                {otherDetails?.returnProductDetails && otherDetails?.returnProductDetails?.length > 0 && otherDetails?.returnProductDetails.map((e, i) => {

                  return (


                    <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "14px" }, fontWeight: "400" }} >

                      {e.product_name}

                    </Typography>

                  )

                })}

              </Grid>
              <Grid xs={2} >

                <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", borderBottom: `1px solid ${Colors.border}`, marginBottom: 2 }} >

                  IMEI Number

                </Typography>

                {otherDetails.productDetails.map((e, i) => {
                  //console.log( e.IMEI, "iemi")
                  return (


                    <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "14px" }, fontWeight: "400" }} >

    {                e?.IMEI != "" && typeof e?.IMEI == "object" ? <>
                    {e?.IMEI?.map((it)=>{
                      return(
                        <Text sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "14px" }, fontWeight: "400" }} >{it},{' '} </Text>
                      )
                    })}
                      </> : <Text sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "14px" }, fontWeight: "400" }} >{e?.IMEI} </Text>}

                     </Typography>

                  )

                })}

                {otherDetails?.returnProductDetails && otherDetails?.returnProductDetails?.length > 0 && otherDetails?.returnProductDetails.map((e, i) => {

                  return (


                    <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "14px" }, fontWeight: "400" }} >

                      {e.product_name}

                    </Typography>

                  )

                })}

              </Grid>

              <Grid xs={1} >


                <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", borderBottom: `1px solid ${Colors.border}`, marginBottom: 2 }} >

                  Quantity

                </Typography>

                {otherDetails.productDetails.map((e, i) => {

                  return (


                    <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "14px" }, fontWeight: "400" }} >

                      {e.DamageQty ? e.DamageQty : e.saleQty}

                    </Typography>

                  )

                })}

                {otherDetails?.returnProductDetails && otherDetails?.returnProductDetails?.length > 0 && otherDetails.returnProductDetails.map((e, i) => {

                  return (


                    <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "14px" }, fontWeight: "400" }} >

                      -{e.DamageQty ? e.DamageQty : e.saleQty}

                    </Typography>

                  )

                })}

              </Grid>

              <Grid xs={1} >


                <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", borderBottom: `1px solid ${Colors.border}`, marginBottom: 2 }} >

                  Price

                </Typography>



                {otherDetails.productDetails.map((e, i) => {

                  return (


                    <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "14px" }, fontWeight: "400" }} >

                      £{otherDetails?.saleReturnDate && "-"}

                      {e?.discountPrice > (otherDetails?.customerDetails[0]?.priceLevel[0]?.id ==
                        1 ? e?.trade_price : otherDetails?.customerDetails[0]?.priceLevel[0]?.id ==
                          2 ? e?.warehouse_price : e?.retail_price) ? e?.discountPrice : otherDetails?.customerDetails[0]?.priceLevel[0]?.id ==
                            1
                        ? Number(e.trade_price).toFixed(2)
                        : otherDetails?.customerDetails[0]?.priceLevel[0]
                          ?.id == 2
                          ? Number(e.warehouse_price).toFixed(2)
                          : Number(e.retail_price).toFixed(2)}
                    </Typography>

                  )

                })}


                {otherDetails?.returnProductDetails && otherDetails?.returnProductDetails?.length > 0 && otherDetails.returnProductDetails.map((e, i) => {

                  return (


                    <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "14px" }, fontWeight: "400" }} >

                      £-{otherDetails?.customerDetails[0]?.accountManager == "A" ? Number(e?.trade_price).toFixed(2) : otherDetails?.customerDetails[0]?.accountManager == "B" ? Number(e?.warehouse_price).toFixed(2) : Number(e?.retail_price).toFixed(2)}

                    </Typography>

                  )

                })}

              </Grid>

              <Grid xs={1} >


                <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", borderBottom: `1px solid ${Colors.border}`, marginBottom: 2 }} >

                  Discount

                </Typography>

                {otherDetails.productDetails.map((e, i) => {

                  return (


                    <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "14px" }, fontWeight: "400" }} >

                      £
                      {(e.discountPrice < (otherDetails?.customerDetails[0]?.priceLevel[0]?.id ==
                        1 ? e?.trade_price : otherDetails?.customerDetails[0]?.priceLevel[0]?.id ==
                          2 ? e?.warehouse_price : e?.retail_price))
                        ? Number(
                          (otherDetails?.customerDetails[0]?.priceLevel[0]
                            ?.id == 1
                            ? e.trade_price
                            : otherDetails?.customerDetails[0]
                              ?.priceLevel[0]?.id == 2
                              ? e.warehouse_price
                              : e.retail_price) - e.discountPrice
                        ).toFixed(2)
                        : 0}
                    </Typography>

                  )

                })}

                {otherDetails?.returnProductDetails && otherDetails?.returnProductDetails?.length > 0 && otherDetails.returnProductDetails.map((e, i) => {

                  return (


                    <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "14px" }, fontWeight: "400" }} >

                      £{e?.discountPrice ? (Number(otherDetails?.customerDetails[0]?.accountManager == "A" ? e?.trade_price : otherDetails?.customerDetails[0]?.accountManager == "B" ? e?.warehouse_price : e?.retail_price) - e?.discountPrice).toFixed(2) : 0}

                    </Typography>

                  )

                })}

              </Grid>


              <Grid xs={2} >


                <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", borderBottom: `1px solid ${Colors.border}`, marginBottom: 2 }} >

                  Amount

                </Typography>

                {otherDetails.productDetails.map((e, i) => {

                  return (


                    <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "14px" }, fontWeight: "400" }} >

                      £{e?.discountPrice ? Number(e?.discountPrice * (e.DamageQty ? e.DamageQty : e.saleQty)).toFixed(2) :
                        Number((otherDetails?.customerDetails[0]?.accountManager == "A" ? Number(e?.trade_price) : otherDetails?.customerDetails[0]?.accountManager == "B" ? e?.warehouse_price : e?.retail_price) * (e.DamageQty ? e.DamageQty : e.saleQty)).toFixed(2)}

                    </Typography>

                  )

                })}


                {otherDetails?.returnProductDetails && otherDetails?.returnProductDetails?.length > 0 && otherDetails.returnProductDetails.map((e, i) => {

                  return (


                    <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "14px" }, fontWeight: "400" }} >

                      £-{e?.discountPrice ? Number(e?.discountPrice * (e.DamageQty ? e.DamageQty : e.saleQty)).toFixed(2) : (
                        Number((otherDetails?.customerDetails[0]?.accountManager == "A" ? e?.trade_price
                          : otherDetails?.customerDetails[0]?.accountManager == "B" ? e?.warehouse_price
                            : e?.retail_price) * (e.DamageQty ? e.DamageQty : e.saleQty))).toFixed(2)}

                    </Typography>

                  )

                })}

              </Grid>




            </Grid> */}
            <TableContainer component={Paper} sx={{ marginTop: 2 }}>
  <Table>
    <TableHead>
      <TableRow>
        <TableCell style={{width:"35%"}}><strong>Product Name</strong></TableCell>
        <TableCell style={{width:"15%"}}><strong>IMEI Number</strong></TableCell>
        <TableCell style={{width:"12%"}}><strong>Quantity</strong></TableCell>
        <TableCell style={{width:"12%"}}><strong>Price</strong></TableCell>
        {(otherDetails?.paymentMethod!="Credit Note"&&selectedCustomer?.showDiscount)?<TableCell style={{width:"12%"}}><strong>Discount</strong></TableCell>:<TableCell style={{width:"12%"}}></TableCell>}
        <TableCell style={{width:"12%"}}><strong>Amount</strong></TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {[...(otherDetails.productDetails || [])].map((e, i) => (
        <TableRow key={i}>
          {/* Product Name */}
          <TableCell style={{width:"35%"}}>
            {e?.productName || e?.product_name}
          </TableCell>

          {/* IMEI */}
          <TableCell style={{width:"15%"}}>
            {e?.IMEI && typeof e?.IMEI === 'object'
              ? e.IMEI.join(' ')
              : e?.IMEI || ''}
          </TableCell>

          {/* Quantity */}
          <TableCell style={{width:"12%"}}>
            {i < otherDetails.productDetails.length && otherDetails?.saleReturnDate ? '-' : ''}
            {i < otherDetails.productDetails.length
              ? e.DamageQty || e.saleQty
              : `-${e.DamageQty || e.saleQty}`}
          </TableCell>

          {/* Price */}
          <TableCell style={{width:"12%"}}>
            £{i < otherDetails.productDetails.length && otherDetails?.saleReturnDate ? '-' : ''}
            {
             selectedCustomer?.showDiscount?
              (i < otherDetails.productDetails.length
                ? (
                  e.discountPrice > (
                    otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 1
                      ? e.trade_price
                      : otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 2
                        ? e.warehouse_price
                         : otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 4
                          ? e.diamond
                        : e.retail_price
                  )
                    ? e.discountPrice
                    : Number(
                      otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 1
                        ? e.trade_price
                        : otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 2
                          ? e.warehouse_price
                           : otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 4
                          ? e.diamond
                          : e.retail_price
                    ).toFixed(2)
                )
                : `-${Number(
                  otherDetails?.customerDetails[0]?.accountManager === 'A'
                    ? e.trade_price
                    : otherDetails?.customerDetails[0]?.accountManager === 'B'
                      ? e.warehouse_price
                      : otherDetails?.customerDetails[0]?.accountManager === 'D'
                      ? e.diamond
                      : e.retail_price
                ).toFixed(2)}`):(i < otherDetails.productDetails.length
              ? (
                e?.discountPrice
                  ? Number(e?.discountPrice).toFixed(2)
                  : Number(
                    (otherDetails?.customerDetails[0]?.accountManager === 'A'
                      ? e.trade_price
                      : otherDetails?.customerDetails[0]?.accountManager === 'B'
                        ? e.warehouse_price
                        : otherDetails?.customerDetails[0]?.accountManager === 'D'
                      ? e.diamond
                        : e.retail_price)
                  ).toFixed(2)
              )
              : `-${
                e?.discountPrice
                  ? Number(e?.discountPrice).toFixed(2)
                  : Number(
                    (otherDetails?.customerDetails[0]?.accountManager === 'A'
                      ? e.trade_price
                      : otherDetails?.customerDetails[0]?.accountManager === 'B'
                        ? e.warehouse_price
                        : otherDetails?.customerDetails[0]?.accountManager === 'D'
                      ? e.diamond
                        : e.retail_price)
                  ).toFixed(2)
              }`)
            }
          </TableCell>

          {/* Discount */}
         {(otherDetails?.paymentMethod!="Credit Note"&&selectedCustomer?.showDiscount)? <TableCell style={{width:"12%"}}>
          £{i < otherDetails.productDetails.length && otherDetails?.saleReturnDate ? '-' : ''}
            {
              i < otherDetails.productDetails.length
                ? (e.discountPrice < (
                  otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 1
                    ? e.trade_price
                    : otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 2
                      ? e.warehouse_price
                       : otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 4
                          ? e.diamond
                      : e.retail_price
                )
                  ?otherDetails.status=="Return"? Number(
                 Number(e?.discountPrice )?   (Number(e?.discountPrice )||(otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 1
                      ? e.trade_price
                      : otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 2
                        ? e.warehouse_price
                         : otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 4
                          ? e.diamond
                        : e.retail_price)) - e.cost_price:0
                  ).toFixed(2):Number(
                    ((otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 1
                      ? e.trade_price
                      : otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 2
                        ? e.warehouse_price
                         : otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 4
                          ? e.diamond
                        : e.retail_price)) - e?.discountPrice 
                  ).toFixed(2)
                  : 0)
                : (e.discountPrice
                  ? Number(
                    (otherDetails?.customerDetails[0]?.accountManager === 'A'
                      ? e.trade_price
                      : otherDetails?.customerDetails[0]?.accountManager === 'B'
                        ? e.warehouse_price
                         : otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 4
                          ? e.diamond
                        : e.retail_price) - e.discountPrice-e.cost_price
                  ).toFixed(2)
                  : 0)
            }
          </TableCell>:<TableCell style={{width:"12%"}}></TableCell>}

          {/* Amount */}
          <TableCell style={{width:"12%"}}>
            £{i < otherDetails.productDetails.length && otherDetails?.saleReturnDate ? '-' : ''}
            {i < otherDetails.productDetails.length
              ? (
                e?.discountPrice
                  ? Number(e?.discountPrice * (e.DamageQty || e.saleQty)).toFixed(2)
                  : Number(
                    (otherDetails?.customerDetails[0]?.accountManager === 'A'
                      ? e.trade_price
                      : otherDetails?.customerDetails[0]?.accountManager === 'B'
                        ? e.warehouse_price
                        : otherDetails?.customerDetails[0]?.accountManager === 'D'
                      ? e.diamond
                        : e.retail_price) * (e.DamageQty || e.saleQty)
                  ).toFixed(2)
              )
              : `-${
                e?.discountPrice
                  ? Number(e?.discountPrice * (e.DamageQty || e.saleQty)).toFixed(2)
                  : Number(
                    (otherDetails?.customerDetails[0]?.accountManager === 'A'
                      ? e.trade_price
                      : otherDetails?.customerDetails[0]?.accountManager === 'B'
                        ? e.warehouse_price
                        : otherDetails?.customerDetails[0]?.accountManager === 'D'
                      ? e.diamond
                        : e.retail_price) * (e.DamageQty || e.saleQty)
                  ).toFixed(2)
              }`
            }
          </TableCell>
        </TableRow>
      ))}
     
    </TableBody>
  </Table>

            <div container xs={12} style={{ marginTop: 15,display:"flex" }} >

              <div style={{width:"52%"}} >



                <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", borderTop: `1px solid ${Colors.border}`, marginBottom: 2 }} >

                  {otherDetails?.returnSubtotal?"Sale ":""}Subtotal

                </Typography>


              </div>

              <div xs={1} style={{width:"12%"}} >



                <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", borderTop: `1px solid ${Colors.border}`, marginBottom: 2 }} >
{otherDetails.productDetails.length && otherDetails?.saleReturnDate ? '-' : ''}
                  {otherDetails?.productDetails&&otherDetails?.productDetails.reduce((a,b)=>{
                    return otherDetails?.saleReturnDate?b?.DamageQty?a+b?.DamageQty:a+b?.saleQty:a+b?.saleQty
                  },0)}

                </Typography>


              </div>

              <div xs={1} style={{width:"12%"}} >



                <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", borderTop: `1px solid ${Colors.border}`, marginBottom: 2 }} >


                </Typography>


              </div>




             { <div xs={1} style={{width:"12%"}} >



               {(otherDetails?.paymentMethod!="Credit Note"&&selectedCustomer?.showDiscount)&& <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", borderTop: `1px solid ${Colors.border}`, marginBottom: 2 }} >

                  £{otherDetails.discount ? Number(otherDetails.discount).toFixed(2) : 0}

                </Typography>}


              </div>}

              <div xs={2} style={{width:"12%"}} >



                <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", borderTop: `1px solid ${Colors.border}`, marginBottom: 2 }} >
£{ otherDetails.productDetails.length && otherDetails?.saleReturnDate ? '-' : ''}
                  {Number(otherDetails.total - (otherDetails?.discount || 0)).toFixed(2)}

                </Typography>


              </div>



            </div>
            {(otherDetails?.SDAmount != 0 &&otherDetails?.SDAmount != null&&otherDetails?.SDAmount != undefined) && (
              <div container xs={12} style={{ paddingTop:5,margin:"10px 0",display:"flex",borderTop:`solid ${Colors.border} 1px` }} >
                {/* <View
                // key={index}
                style={{
                  flexDirection: "row",
                  // borderWidth: 1,
                  borderLeftWidth: 1,
                  borderRightWidth: 1,
                  borderColor: "#000",
                  borderTopWidth: 1,
                  padding: "5px 10px",
                }}
              > */}
                <div xs={10} style={{width:"88%"}} >
                  <Text
                    style={{
                      fontFamily: "Poppins",
                      fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" },
                      fontWeight: "bold",
                    }}
                  >
                    Special Discount  {(
                    (otherDetails?.SDAmount /
                      (otherDetails?.total
                        //  +
                        // (otherDetails?.vatAmount || 0)
                         -
                        (otherDetails?.discount || 0))) *
                    100
                  ).toFixed(2)}
                  %
                  </Text>
                </div>

                <div xs={2} style={{width:"12%"}} >
                  <Text
                    style={{
                      fontFamily: "Poppins",
                      fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" },
                      fontWeight: "bold",
                    }}
                  >
                    -£{Number(otherDetails?.SDAmount).toFixed(2)}

                    {/* - £{Number(printInvoiceData?.SDAmount).toFixed(2)} */}
                  </Text>
                </div>
                {/* </View> */}
              </div>
            )}
              {(otherDetails?.returnSubtotal&&(otherDetails?.vatAmount||otherDetails?.SDAmount))?((otherDetails?.SDAmount||otherDetails?.vatAmount) ?<></>: (
              <div container xs={12} style={{ paddingTop:5,margin:"10px 0",display:"flex",borderTop:`solid ${Colors.border} 1px` }} >
                {/* <View
                // key={index}
                style={{
                  flexDirection: "row",
                  // borderWidth: 1,
                  borderLeftWidth: 1,
                  borderRightWidth: 1,
                  borderColor: "#000",
                  borderTopWidth: 1,
                  padding: "5px 10px",
                }}
              > */}
                <div xs={10} style={{width:"88%"}} >
                  <Text
                    style={{
                      fontFamily: "Poppins",
                      fontSize: {  xs: "10px", sm: "12px", md: "14px", lg: "16px" },
                      fontWeight: "bold",
                    }}
                  >
                    Return Subtotal  
                  </Text>
                </div>

                <div xs={2} style={{width:"12%"}} >
                  <Text
                    style={{
                      fontFamily: "Poppins",
                      fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" },
                      fontWeight: "bold",
                    }}
                  >
                    -£{(otherDetails?.returnSubtotal||0).toFixed(2)} 

                    {/* - £{Number(printInvoiceData?.SDAmount).toFixed(2)} */}
                  </Text>
                </div>
                {/* </View> */}
              </div>
            )):<></>}
            {((otherDetails.SDAmount))?(<div container xs={12} sx={{ marginTop: 2 }} style={{ display:"flex",borderTop: `1px solid ${Colors.border}`,paddingTop:5 }} >

              <div xs={7} style={{width:"52%"}} >



                <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", marginBottom: 2 }} >

                  Subtotal

                </Typography>


              </div>

              <div xs={1} style={{width:"12%"}} >



                <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", marginBottom: 2 }} >
{otherDetails.productDetails.length && otherDetails?.saleReturnDate ? '-' : ''}
                  {(otherDetails?.productDetails&&otherDetails?.productDetails.reduce((a,b)=>{
                    return otherDetails?.saleReturnDate?b?.DamageQty?a+b?.DamageQty:a+b?.saleQty:a+b?.saleQty
                  },0))}

                </Typography>


              </div>

              <div xs={1} style={{width:"12%"}} >



                <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", marginBottom: 2 }} >


                </Typography>


              </div>




             { <div xs={1} style={{width:"12%"}} >



                {(otherDetails?.paymentMethod!="Credit Note"&&selectedCustomer?.showDiscount)&&<Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", marginBottom: 2 }} >
{/* £{ otherDetails.productDetails.length && otherDetails?.saleReturnDate ? '-' : ''} */}
                  £{otherDetails.discount ? Number(otherDetails.discount).toFixed(2) : 0}

                </Typography>}


              </div>}

              <div xs={2} style={{width:"12%"}} >



                <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", marginBottom: 2 }} >
£{ otherDetails.productDetails.length && otherDetails?.saleReturnDate ? '-' : ''}
                  {(Number(otherDetails?.total) - Number(otherDetails?.discount)-Number(otherDetails?.SDAmount)-(otherDetails?.SDAmount?0:Number(otherDetails?.returnSubtotal||0))).toFixed(2)}

                </Typography>


              </div>



            </div>):<></>}


            {otherDetails.vatAmount ?
              <div container xs={12} style={{ display:"flex",borderTop: `1px solid ${Colors.border}`,paddingTop:5 }} >

                <div item xs={9} style={{width:"88%"}} >


                  <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", marginBottom: 2 }} >

                    VAT

                  </Typography>


                </div>


                <div item xs={2} style={{width:"12%"}} >


                  <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", marginBottom: 2 }} >
£{otherDetails?.saleReturnDate&& otherDetails?.saleReturnDate ? '-' : ''}
                    {Number(otherDetails.vatAmount).toFixed(2)}

                  </Typography>


                </div>

              </div> : ""}
            {(otherDetails?.returnSubtotal&&(otherDetails?.vatAmount||otherDetails?.SDAmount)) ?
              <div container xs={12} style={{ display:"flex",borderTop: `1px solid ${Colors.border}`,borderBottom: `1px solid ${Colors.border}`,paddingTop:5 }} >

                <div item xs={9} style={{width:"88%"}} >


                  <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", marginBottom: 2 }} >

                    Total

                  </Typography>


                </div>


                <div item xs={2} style={{width:"12%"}} >


                  <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", marginBottom: 2 }} >
£{(Number(otherDetails.vatAmount||0)+(Number((otherDetails.total||0) - (otherDetails?.discount || 0)))-Number(otherDetails?.SDAmount||0)).toFixed(2)}

                  </Typography>


                </div>

              </div> : ""}

 {(otherDetails?.returnSubtotal)?((
             <>
              <Table>
              <TableBody>
                {[...(otherDetails.returnProductDetails || [])].map((e, i) => (
        <TableRow key={i}>
          {/* Product Name */}
          <TableCell style={{width:"35%"}}>
            {e?.productName || e?.product_name}
          </TableCell>

          {/* IMEI */}
          <TableCell style={{width:"15%"}}>
            {e?.IMEI && typeof e?.IMEI === 'object'
              ? e.IMEI.join(' ')
              : e?.IMEI || ''}
          </TableCell>

          {/* Quantity */}
          <TableCell style={{width:"12%"}}>
            { `-${e.DamageQty || e.saleQty}`}
          </TableCell>

          {/* Price */}
          <TableCell style={{width:"12%"}}>
            £{otherDetails?.saleReturnDate ? '-' : ''}
            {
             selectedCustomer?.showDiscount?
              ( `-${Number(
                  otherDetails?.customerDetails[0]?.accountManager === 'A'
                    ? e.trade_price
                    : otherDetails?.customerDetails[0]?.accountManager === 'B'
                      ? e.warehouse_price:
                      otherDetails?.customerDetails[0]?.accountManager === 'D'
                      ? e.diamond
                      : e.retail_price
                ).toFixed(2)}`):(i < otherDetails.productDetails.length
              ? (
                e?.discountPrice
                  ? Number(e?.discountPrice).toFixed(2)
                  : Number(
                    (otherDetails?.customerDetails[0]?.accountManager === 'A'
                      ? e.trade_price
                      : otherDetails?.customerDetails[0]?.accountManager === 'B'
                        ? e.warehouse_price:
                      otherDetails?.customerDetails[0]?.accountManager === 'D'
                      ? e.diamond
                        : e.retail_price)
                  ).toFixed(2)
              )
              : `-${
                e?.discountPrice
                  ? Number(e?.discountPrice).toFixed(2)
                  : Number(
                    (otherDetails?.customerDetails[0]?.accountManager === 'A'
                      ? e.trade_price
                      : otherDetails?.customerDetails[0]?.accountManager === 'B'
                        ? e.warehouse_price:
                      otherDetails?.customerDetails[0]?.accountManager === 'D'
                      ? e.diamond
                        : e.retail_price)
                  ).toFixed(2)
              }`)
            }
          </TableCell>

          {/* Discount */}
         {(otherDetails?.paymentMethod!="Credit Note"&&selectedCustomer?.showDiscount)? <TableCell style={{width:"12%"}}>
          £{ otherDetails?.saleReturnDate ? '-' : ''}
            {
              i < otherDetails.productDetails.length
                ? (e.discountPrice < (
                  otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 1
                    ? e.trade_price
                    : otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 2
                      ? e.warehouse_price
                       : otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 4
                          ? e.diamond
                      : e.retail_price
                )
                  ?otherDetails.status=="Return"? Number(
                 Number(e?.discountPrice )?   (Number(e?.discountPrice )||(otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 1
                      ? e.trade_price
                      : otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 2
                        ? e.warehouse_price
                         : otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 4
                          ? e.diamond
                        : e.retail_price)) - e.cost_price:0
                  ).toFixed(2):Number(
                    ((otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 1
                      ? e.trade_price
                      : otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 2
                        ? e.warehouse_price
                         : otherDetails?.customerDetails[0]?.priceLevel[0]?.id === 4
                          ? e.diamond
                        : e.retail_price)) - e?.discountPrice 
                  ).toFixed(2)
                  : 0)
                : (e.discountPrice
                  ? Number(
                    (otherDetails?.customerDetails[0]?.accountManager === 'A'
                      ? e.trade_price
                      : otherDetails?.customerDetails[0]?.accountManager === 'B'
                        ? e.warehouse_price
                        : otherDetails?.customerDetails[0]?.accountManager === 'D'
                      ? e.diamond
                        : e.retail_price) - e.discountPrice-e.cost_price
                  ).toFixed(2)
                  : 0)
            }
          </TableCell>:<TableCell style={{width:"12%"}}></TableCell>}

          {/* Amount */}
          <TableCell style={{width:"12%"}}>
            £
            { `-${
                e?.discountPrice
                  ? Number(e?.discountPrice * (e.DamageQty || e.saleQty)).toFixed(2)
                  : Number(
                    (otherDetails?.customerDetails[0]?.accountManager === 'A'
                      ? e.trade_price
                      : otherDetails?.customerDetails[0]?.accountManager === 'B'
                        ? e.warehouse_price
                        : otherDetails?.customerDetails[0]?.accountManager === 'D'
                      ? e.diamond
                        : e.retail_price) * (e.DamageQty || e.saleQty)
                  ).toFixed(2)
              }`
            }
          </TableCell>
        </TableRow>
      ))}
              </TableBody>
              </Table>
              {(otherDetails?.returnSd != 0 &&otherDetails?.returnSd != null&&otherDetails?.returnSd != undefined) && (
              <div container xs={12} style={{ paddingTop:5,margin:"10px 0",display:"flex",borderTop:`solid ${Colors.border} 1px` }} >
                {/* <View
                // key={index}
                style={{
                  flexDirection: "row",
                  // borderWidth: 1,
                  borderLeftWidth: 1,
                  borderRightWidth: 1,
                  borderColor: "#000",
                  borderTopWidth: 1,
                  padding: "5px 10px",
                }}
              > */}
                <div xs={10} style={{width:"88%"}} >
                  <Text
                    style={{
                      fontFamily: "Poppins",
                      fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" },
                      fontWeight: "bold",
                    }}
                  >
                    Special Discount
                  </Text>
                </div>

                <div xs={2} style={{width:"12%"}} >
                  <Text
                    style={{
                      fontFamily: "Poppins",
                      fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" },
                      fontWeight: "bold",
                    }}
                  >
                    -£{Number(otherDetails?.returnSd).toFixed(2)}

                    {/* - £{Number(printInvoiceData?.SDAmount).toFixed(2)} */}
                  </Text>
                </div>
                {/* </View> */}
              </div>
            )}
              {otherDetails.returnVat ?
              <div container xs={12} style={{ display:"flex",borderTop: `1px solid ${Colors.border}`,paddingTop:5 }} >

                <div item xs={9} style={{width:"88%"}} >


                  <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", marginBottom: 2 }} >

                    VAT

                  </Typography>


                </div>


                <div item xs={2} style={{width:"12%"}} >


                  <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", marginBottom: 2 }} >
-£
                    {Number(otherDetails.returnVat).toFixed(2)}

                  </Typography>


                </div>

              </div> : ""}
               <div container xs={12} style={{ paddingTop:5,margin:"10px 0",display:"flex",borderTop:`solid ${Colors.border} 1px` }} >
                {/* <View
                // key={index}
                style={{
                  flexDirection: "row",
                  // borderWidth: 1,
                  borderLeftWidth: 1,
                  borderRightWidth: 1,
                  borderColor: "#000",
                  borderTopWidth: 1,
                  padding: "5px 10px",
                }}
              > */}
                <div xs={10} style={{width:"88%"}} >
                  <Text
                    style={{
                      fontFamily: "Poppins",
                      fontSize: {  xs: "10px", sm: "12px", md: "14px", lg: "16px" },
                      fontWeight: "bold",
                    }}
                  >
                    Return Subtotal 
                  </Text>
                </div>

                <div xs={2} style={{width:"12%"}} >
                  <Text
                    style={{
                      fontFamily: "Poppins",
                      fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" },
                      fontWeight: "bold",
                    }}
                  >
                    -£{(otherDetails?.returnSubtotal||0).toFixed(2)} 

                    {/* - £{Number(printInvoiceData?.SDAmount).toFixed(2)} */}
                  </Text>
                </div>
                {/* </View> */}
              </div>
             </>
            )):<></>}

            {
              <div container xs={12} style={{ display:"flex" }} >

                <div item xs={9} style={{ borderTop: `1px solid ${Colors.border}`,width:"88%",paddingTop:5 }}  >


                  <Typography sx={{ textAlign: "center", fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", marginBottom: 2, color: Colors.red }} >

                    Grand Total

                  </Typography>


                </div>


                <div item xs={3} style={{ borderTop: `1px solid ${Colors.border}`,width:"12%",paddingTop:5 }}   >


                  <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "10px", sm: "12px", md: "14px", lg: "16px" }, fontWeight: "bold", marginBottom: 2, color: Colors.red }} >
£{ otherDetails.productDetails.length && otherDetails?.saleReturnDate ? '-' : ''}
                    {Number(otherDetails.subtotal).toFixed(2)}

                  </Typography>


                </div>

              </div> }
</TableContainer>

          </div>


          <Box>

            <Typography style={{ fontSize: 15, fontWeight: "500", color: Colors.black, fontFamily: "Poppins" }} >This invoice has been served by <span style={{ fontSize: 16, fontWeight: "bold", color: Colors.red, fontFamily: "Poppins" }} >{otherDetails?.employeeDetails?.[0]?.fullName}</span></Typography>

          </Box>

          {(userData?.role === "admin" || userData?.role_access?.some((e, i) => e.name.toLowerCase() == "showprofit" && e?.selected)) && (
            <Typography style={{ fontSize: "12px", fontFamily: "Poppins", fontWeight: "bold" }}>
              {otherDetails?.saleReturnDate ? "Loss" :
                Number(
  (
//             Math.abs(otherDetails?.type!="exchange"?otherDetails?.subtotal || 0:otherDetails?.saleSubtotal
//  || 0)
//             // - (otherDetails?.discount || 0)
//             -
             
             (
  (otherDetails?.productDetails || []).reduce((sum, i) => {
    const qty =
      otherDetails.type == "return"
        ? ((i?.DamageQty ? i?.DamageQty : i?.returnQty)||i?.saleQty)
        : (i?.DamageQty ||i?.saleQty);

    return sum + ((i?.rate - i?.cost_price) * (qty || 0));
  }, 0)
  -
  (otherDetails?.returnProductDetails || []).reduce((sum, i) => {
    const qty =
      otherDetails.type == "return"
        ? ((i?.DamageQty ? i?.DamageQty : i?.returnQty)||i?.saleQty)
        : (i?.DamageQty ||i?.saleQty);

    return sum + ((i?.rate - i?.cost_price) * (qty || 0));
  }, 0)
)
// - (otherDetails?.discount || 0)
- ((otherDetails?.SDAmount || 0)
-(otherDetails?.returnSd||0))
        ) 
) < 0 ?
                  "Loss" : "PF"

              }: {Math.abs(
    Number(
        (
//             Math.abs(otherDetails?.type!="exchange"?otherDetails?.subtotal || 0:otherDetails?.saleSubtotal
//  || 0)
//             // - (otherDetails?.discount || 0)
//             -
             
             (
  (otherDetails?.productDetails || []).reduce((sum, i) => {
    const qty =
      otherDetails.type == "return"
        ? ((i?.DamageQty ? i?.DamageQty : i?.returnQty)||i?.saleQty)
        : (i?.DamageQty ||i?.saleQty);

    return sum + ((i?.rate - i?.cost_price) * (qty || 0));
  }, 0)
  -
  (otherDetails?.returnProductDetails || []).reduce((sum, i) => {
    const qty =
      otherDetails.type == "return"
        ? ((i?.DamageQty ? i?.DamageQty : i?.returnQty)||i?.saleQty)
        : (i?.DamageQty ||i?.saleQty);

    return sum + ((i?.rate - i?.cost_price) * (qty || 0));
  }, 0)
)
// - (otherDetails?.discount || 0)
- ((otherDetails?.SDAmount || 0)
-(otherDetails?.returnSd||0))
        ) 
    )
).toFixed(2)}

            </Typography>
          )}


          <Box sx={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "center", ...buttonContainerStyle }} >

            <Button onClick={closeModal} sx={{
              backgroundColor: "#5DC002", color: Colors.white, border: `1px solid ${Colors.button}`, borderRadius: "20px", width: "200px", fontSize: "14px", textTransform: "capitalize", mt: 1, fontFamily: "Poppins",
              '&:hover': {
                color: '#5DC002', // Set your desired hover color
              },
              ...buttonStyle
            }} >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}

export default React.forwardRef(InvoiceModal)